export class EventSourceManager {
  _name: string;
  _eventSource: EventSource | null = null;

  constructor(name: string) {
    this._name = name;
  }

  init(url: string) {
    if (!this._eventSource) {
      this._eventSource = new EventSource(url);
      window[this._name] = this._eventSource;
    }
  }

  close() {
    if (window[this._name]) {
      (window[this._name] as EventSource).close();
      window[this._name] = undefined;
    }
  }

  subscribe(handler: (event: MessageEvent<string>) => void) {
    this._eventSource?.addEventListener('message', handler);
  }

  unsubscribe(handler: (event: MessageEvent<string>) => void) {
    this._eventSource?.removeEventListener('message', handler);
  }

  addErrorHandler(handler: (err: Event) => void) {
    this._eventSource?.addEventListener('error', handler);
  }

  removeErrorHandler(handler: (err: Event) => void) {
    this._eventSource?.removeEventListener('error', handler);
  }

  get isInitialized() {
    return Boolean(window[this._name]);
  }
}
